import { render, staticRenderFns } from "./AlternativeTitlesEditPanel.vue?vue&type=template&id=6fbfafb0"
import script from "./AlternativeTitlesEditPanel.vue?vue&type=script&lang=js"
export * from "./AlternativeTitlesEditPanel.vue?vue&type=script&lang=js"
import style0 from "./AlternativeTitlesEditPanel.vue?vue&type=style&index=0&id=6fbfafb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports